import api from '@/services/api'

const deleteFeed = (path) => {
  return api.delete(path).then(async ({data}) => {
    return data
  }).catch((err) => {
    console.error('Delete feed failure:', err)
    throw err
  })
}

const getFeed = (feedId) => {
  return api.get(`/feeds/${feedId}`).then(async ({data}) => {
    return data
  })
}

const updateFeed = (feed, payload) => {
  return api.post(feed, payload).then(async ({data}) => {
    return data
  }).catch((err) => {
    console.error('Update feed failure:', err)
    throw err
  })
}

export default {
  deleteFeed,
  getFeed,
  updateFeed
}
